import React, { FC } from "react";
import { Route, Routes } from "react-router-dom";

import NotFoundView from "../errors/NotFoundView";
import Edit from "./Edit";
import List from "./List";

const View: FC = () => {
  return (
    <Routes>
      <Route index element={<List />} />
      <Route path="create" element={<Edit />} />
      <Route path=":policyId/edit" element={<Edit />} />
      <Route path="*" element={<NotFoundView />} />
    </Routes>
  );
};

export default View;
